import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProgramHcpPage } from './program-hcp';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

@NgModule({
  declarations: [
    ProgramHcpPage,
  ],
  imports: [
    IonicPageModule.forChild(ProgramHcpPage),
    NgxDatatableModule
  ],
})
export class ProgramHcpPageModule {}



// WEBPACK FOOTER //
// ./src/pages/program-hcp/program-hcp.module.ts